export default __webpack_public_path__ + "static/media/img-banner01.dfc21893.png";